import React, { Component } from "react";
import PropTypes from "prop-types";

class ProductCard extends Component {
    static propTypes = {
        hit: PropTypes.shape({
            family: PropTypes.shape({
                brand: PropTypes.string.isRequired,
                title: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired,
                image: PropTypes.string.isRequired
            })
        }),
        position: PropTypes.number,
        listType: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        this.hitsObserver = new IntersectionObserver(this.handleIntersection, {
            threshold: 1
        });
    }

    componentDidMount() {
        objectFitPolyfill();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.hit.family.image !== this.props.hit.family.image) {
            objectFitPolyfill();
        }
    }

    componentWillUnmount() {
        this.hitsObserver.disconnect();
    }

    handleIntersection = entries => {
        entries.map(entry => {
            if (entry.isIntersecting) {
                const {
                    hit: {
                        family: { title, brand, categories }
                    },
                    position,
                    listType
                } = this.props;
                const category = categories.lvl1
                    ? categories.lvl1.join("|")
                    : "";

                this.trackImpression(
                    title,
                    category,
                    brand,
                    listType,
                    position
                );

                this.hitsObserver.unobserve(entry.target);
            }
        });
    };

    trackImpression = (name, category, brand, list, position) => {
        const { ga } = window;

        if (!ga) {
            console.warn(
                "Google Analytics is not loaded - Can't track product card impression"
            );
            return;
        }

        // Requiring Enhanced Ecommerce plugin stops queue execution so we know
        // that the other commands after will execute when the tracker is ready
        ga("require", "ec", "ec.js");

        ga("ec:addImpression", {
            name,
            category,
            brand,
            list,
            position // 'position' indicates the product position in the list.
        });

        ga("send", "pageview"); // Send product impressions with initial pageview.
    };

    handleRef = ref => {
        if (this.ref !== ref) {
            if (!this.ref && ref) {
                this.hitsObserver.observe(ref);
            }

            if (this.ref && !ref) {
                this.hitsObserver.unobserve(this.ref);
            }
        }

        this.ref = ref;
    };

    handleClick = event => {
        const {
            hit: {
                family: { title, brand, categories, url }
            },
            position,
            listType
        } = this.props;
        const category = categories.lvl1 ? categories.lvl1.join("|") : "";
        const { ga } = window;

        if (!ga) {
            console.warn(
                "Google Analytics is not loaded - Can't track product card click"
            );
            return;
        }

        event.preventDefault();

        ga("ec:addProduct", {
            name: title,
            category,
            brand,
            position
        });
        ga("ec:setAction", "click", { list: listType });

        // Send click with an event, then send user to product page.
        ga("send", "event", "UX", "click", "Results", {
            hitCallback: () => {
                document.location = url;
            }
        });
    };

    render() {
        const { brand, title, url, image } = this.props.hit.family;

        return (
            <a
                className="product-card product-card--clean"
                href={url}
                ref={this.handleRef}
                onClick={this.handleClick}
            >
                <div className="product-card__card">
                    <div className="product-card__image-wrap">
                        <div className="product-card__image">
                            <img src={image} alt={title} data-object-fit="contain" />
                        </div>
                    </div>
                    <div className="product-card__info">
                        <div className="product-card__family">{title}</div>
                        <div className="product-card__brand">{brand}</div>
                    </div>
                </div>
            </a>
        );
    }
}

export default ProductCard;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/ProductCard.js